{
  "intro": "表計算のファイル（CSV）で、たくさんの商品をまとめて追加・変更できます。先にファイルを確認し、「取り込む」を押すまで何も保存されません。",
  "tabs": {
    "import": "ファイルを取り込む",
    "export": "商品を書き出す",
    "history": "これまでの取り込み"
  },
  "steps": {
    "upload": "1. ファイルを選ぶ",
    "mapping": "2. 列の意味",
    "check": "3. 確認",
    "import": "4. 取り込み"
  },
  "upload": {
    "title": "CSV ファイルを選ぶ",
    "drop": "ここにファイルをドロップ、または",
    "choose": "ファイルを選ぶ",
    "hint": "Excel の場合:「名前を付けて保存 → CSV UTF-8」。20 MB まで。",
    "too_large": "このファイルは {{size}} MB です（上限 20 MB）。ゲームごとなど小さなファイルに分けて、順番に取り込んでください。",
    "not_csv": "CSV ファイルではありません。Excel で「CSV UTF-8（コンマ区切り）」で保存してください。",
    "empty": "このファイルには行がありません。",
    "reading": "ファイルを読み込み中…",
    "templates": "記入用の空ファイル",
    "templates_hint": "正しい形式のファイルをダウンロードし、見本の行を消して記入してください。",
    "template_native": "フル形式（すべての項目）",
    "template_shopify": "Shopify 形式",
    "template_quick_cards": "カード簡易リスト（ゲーム・セット・番号・ランク・価格）"
  },
  "profiles": {
    "native": "当店のフル形式",
    "shopify": "Shopify の書き出し",
    "quick_cards": "カード簡易リスト"
  },
  "mapping": {
    "detected": "このファイルは: {{profile}}",
    "not_detected": "形式がわかりませんでした。形式を選び、各列の意味を指定してください。",
    "layout": "ファイルの形式",
    "column": "ファイルの列",
    "sample": "値の例",
    "field": "意味",
    "skip": "— 取り込まない —",
    "sure": "確実",
    "unsure": "確認してください",
    "remembered": "前回の設定",
    "missing_required": "次の列が必要です: {{fields}}",
    "missing_raw": "未鑑定カードがある場合はランク（A〜D）の列を指定してください: {{fields}}",
    "missing_graded": "鑑定済みカードがある場合は次の列を指定してください: {{fields}}",
    "duplicate": "2つの列が同じ項目になっています: {{fields}}。片方を「取り込まない」にしてください。",
    "check": "ファイルを確認する",
    "back": "別のファイルを選ぶ",
    "rows_in_file": "{{count}} 行",
    "field_of": "列「{{column}}」の意味"
  },
  "check": {
    "running": "{{total}} 行中 {{done}} 行を確認中…",
    "queued": "開始を待っています…",
    "title": "確認の結果",
    "creates": "新しい商品",
    "updates": "変更される商品",
    "errors": "問題のある行",
    "warnings": "確認が必要な行",
    "skips": "変更なし・スキップ",
    "no_errors": "問題は見つかりませんでした。取り込めます。",
    "problem_rows": "問題のある行",
    "row": "ファイルの行",
    "code": "商品",
    "what": "問題の内容",
    "download_problems": "問題のある行だけダウンロード",
    "download_report": "行ごとの結果つきファイルをダウンロード",
    "only_good": "問題のない {{count}} 行だけ取り込む（ほかの行はスキップ）",
    "fix_and_upload": "ファイルを直してもう一度アップロード",
    "import": "取り込む",
    "import_locked": "「問題のない行だけ取り込む」を選ぶか、直したファイルをアップロードしてください。",
    "failed": "ファイルを確認できませんでした: {{error}}",
    "cancel": "中止",
    "cancelled": "中止しました。"
  },
  "rank_map": {
    "title": "ランク列にある古い状態の表記",
    "hint": "当店の未鑑定カードのランクは A / B / C / D です。下の表記ごとにランクを選んでください。このファイルだけが変更され、もう一度確認します。",
    "found": "ファイル内の表記",
    "rows": "行数",
    "rank": "使うランク",
    "apply": "このランクで確認し直す",
    "no_file": "ランクを変えるにはファイルをもう一度選んでください（再読み込み後はブラウザに残りません）。",
    "done": "ファイルのランクを {{count}} 件変更しました",
    "rank_for": "「{{value}}」に使うランク"
  },
  "import": {
    "running": "{{total}} 行中 {{done}} 行を取り込み中…",
    "done_title": "取り込みが終わりました",
    "done": "新規 {{created}} · 変更 {{updated}} · スキップ {{skipped}}",
    "see_products": "取り込んだ商品を見る",
    "another": "別のファイルを取り込む",
    "left_page": "このページを離れても取り込みは続きます。「これまでの取り込み」から戻れます。"
  },
  "history": {
    "empty": "まだ取り込みはありません。",
    "open": "開く",
    "rows": "{{count}} 行",
    "errors_count": "問題 {{count}} 行"
  },
  "status": {
    "queued": "待機中",
    "validating": "確認中",
    "ready": "確認済み",
    "applying": "取り込み中",
    "done": "取り込み済み",
    "failed": "失敗",
    "cancelled": "中止"
  },
  "row_status": {
    "ok": "OK",
    "warning": "OK（要確認）",
    "error": "問題あり",
    "skipped": "スキップ"
  },
  "export": {
    "title": "商品を書き出す",
    "hint": "店のすべての商品を CSV ファイルにします。一部だけ（保存したビュー・絞り込み）は商品一覧の「ダウンロード」を使ってください。",
    "format": "形式",
    "native": "当店のフル形式（もう一度取り込めます）",
    "shopify": "Shopify 形式",
    "download": "ダウンロード",
    "preparing": "ファイルを準備中…",
    "done": "ダウンロードしました",
    "recent": "この端末でダウンロードしたもの",
    "none": "まだダウンロードしていません。"
  },
  "row": {
    "required": "{{field}} は必須です",
    "invalid_value": "{{field}}: 値「{{value}}」は正しくありません",
    "invalid_money": "{{field}}: 金額は円の整数で入力してください（例 19000）",
    "duplicate_in_file": "{{field}}「{{value}}」がファイル内で重複しています（最初は {{firstRow}} 行目）",
    "game_not_found": "ゲーム「{{value}}」がありません。先にカードカタログで追加してください",
    "set_not_found": "このゲームにシリーズ「{{value}}」がありません",
    "set_ambiguous": "シリーズ「{{value}}」は複数の言語版があります。set_language を入力してください",
    "card_not_found": "このシリーズにカード {{value}} がありません（「不足カードを作成」で追加できます）",
    "card_ambiguous": "番号 {{value}} のカードが複数あります。card_name_en を入力してください",
    "card_will_be_created": "カード {{value}} をカードカタログに追加します",
    "category_not_found": "カテゴリー「{{value}}」がありません",
    "invalid_reference": "{{field}}: この行が指すデータはもう存在しません。別のものを指定してください",
    "sku_generated": "商品コードは自動で作成されます",
    "taxable_forced_true": "カードには消費税がかかるため、課税（taxable）を true にしました",
    "price_near_cost": "価格が原価とほぼ同じです（{{price}} / {{cost}}）",
    "seo_duplicate_ignored": "同じ {{field}} が {{count}} 行で使われています。無視して自動作成します",
    "cert_conflict": "バーコード（{{barcode}}）と鑑定番号（{{certNumber}}）が異なります",
    "grade_conflict": "{{field}} のグレード（{{found}}）が grade（{{grade}}）と異なります",
    "legacy_condition_alias_mapped": "「{{value}}」をランク{{rank}}として読み込みました",
    "media_import_deferred": "画像URLは保存しました。画像はメディアサービス接続後に追加されます",
    "status_not_allowed": "status「{{value}}」はここでは使えません（draft か active）",
    "variant_ambiguous": "この商品には複数の選択肢があります。商品コードの列で指定してください",
    "unchanged": "変更なし（スキップ）",
    "title_not_parsed": "タイトルが「カード名 – シリーズ (番号) (JP)」の形ではありません。そのまま保存します",
    "set_unresolved": "カードカタログにシリーズ「{{value}}」がありません。カードに紐付けずに保存します",
    "game_unresolved": "ベンダー「{{value}}」はカードカタログのゲームではありません。ゲームなしで保存します",
    "category_unresolved": "カテゴリー「{{value}}」がありません。カテゴリーなしで保存します",
    "product_type_ambiguous": "鑑定品・生カード・未開封のどれか分かりません（「{{value}}」）。状態の列に {{allowed}} を入力してください",
    "qty_ignored_use_inventory": "数量（{{value}}）は取り込みません。在庫は在庫管理で商品コードを使って入庫してください",
    "card_created_without_name": "カード {{value}} はカタログになかったため「{{name}}」として追加しました。カードカタログで正しい名前にしてください",
    "image_row": "{{firstRow}} 行目の商品の追加画像です",
    "variant_rows_not_supported": "{{handle}}（{{firstRow}} 行目）の2つ目のバリエーションです。カードは1点ずつ別の商品にしてください",
    "card_not_found_kept": "このシリーズにカード {{value}} がありません。カードに紐付けずに保存します",
    "not_applied_because_of_errors": "取り込みませんでした。この行のエラーを直してください",
    "raw_rank_required": "シングルカードにはランク（A/B/C/D）が必要です",
    "legacy_condition_alias_rejected": "「{{value}}」は当店のランクではありません。A〜D を使ってください（候補: {{suggested}}）",
    "invalid_raw_rank": "ランクは A/B/C/D のいずれかです（入力値「{{value}}」）",
    "graded_fields_required": "鑑定品には鑑定会社・グレード・鑑定番号が必要です",
    "invalid_grade": "グレードは 1〜10、0.5 刻みです（PSA は整数）",
    "weight_required": "未開封品には重さ（g）が必要です",
    "duplicate_cert": "この鑑定番号は別の商品で出品中です",
    "duplicate_sku": "この商品コードは既に使われています",
    "duplicate_barcode": "このバーコードは別の商品で使われています",
    "invalid_ean": "バーコードが正しい JAN/EAN-13 ではありません",
    "reserved_handle": "この URL（handle）は予約済みです",
    "handle_recently_used": "この URL（handle）は最近別の商品で使われました",
    "unknown_attribute": "追加項目 {{field}} は定義されていません",
    "invalid_attribute": "追加項目 {{field}} の値が正しくありません",
    "compare_at_type_not_allowed": "シングルカードにメーカー希望小売価格の比較価格は使えません",
    "price_below_cost": "価格（{{price}}）が原価（{{cost}}）を下回っています",
    "export_price_low": "輸出価格が税抜価格よりかなり低いです",
    "invalid_cert_format": "鑑定番号が {{gradingCompany}} の形式と異なります",
    "similar_product_exists": "同じカード・同じ状態の商品が既にあります（{{count}} 件）",
    "publish_blocked": "下書きで保存しました。画像の準備ができたら公開できます",
    "condition_type_mismatch": "状態の種類が商品タイプと合いません",
    "product_type_conflict": "{{field}}: 「{{handle}}」は {{existing}} として登録済みです。別のハンドル・コードにするか商品タイプを直してください",
    "forbidden__publish_not_allowed": "販売開始（ステータス・販売チャネル）には公開の権限が必要です。空欄にするかオーナーに依頼してください",
    "forbidden__write_not_allowed": "このアカウントでは商品の追加・変更はできません",
    "forbidden__master_data_not_allowed": "{{field}}: 未登録のシリーズ・カードの追加にはカタログの権限が必要です",
    "forbidden__consignment_scope_pending": "委託の権限で変更できるのは委託品のみです（インポートではまだ使えません）",
    "conflict": "{{field}} は別の商品で使われています",
    "validation_failed__matches_auto_pattern": "{{field}}: 当店形式（{{pattern}}）のコードはシステムが作成します。空欄にするか別のコードにしてください",
    "validation_failed__invalid_format": "{{field}}: 「{{value}}」に使えない文字があります（{{allowed}}）",
    "validation_failed": "{{field}}: 値を確認してください"
  },
  "fields": {
    "external_ref": "自分の管理番号",
    "handle": "URL に使う名前",
    "product_type": "種類（未鑑定・鑑定済み・未開封）",
    "game_slug": "ゲーム",
    "set_code": "セットコード",
    "set_language": "カードの言語",
    "set_name_en": "セット名（英語）",
    "card_number": "カード番号",
    "card_name_en": "カード名（英語）",
    "title_en": "商品名（英語）",
    "title_ja": "商品名（日本語）",
    "description_en": "説明（英語）",
    "detail_text": "詳細",
    "category_slug": "カテゴリ",
    "tags": "タグ",
    "status": "状態（販売中・下書き）",
    "sales_channels": "販売場所",
    "vendor": "メーカー・ブランド",
    "sku": "商品コード",
    "barcode": "バーコード（JAN）",
    "price": "価格（円・税込）",
    "compare_at_price": "参考価格",
    "compare_at_evidence_type": "参考価格の根拠",
    "compare_at_source_url": "参考価格のリンク",
    "compare_at_methodology": "参考価格の調べ方",
    "export_price": "海外向け価格",
    "cost": "仕入価格",
    "weight_g": "重さ（g）",
    "taxable": "消費税の対象",
    "raw_rank": "ランク（A〜D）",
    "raw_rank_damaged": "ダメージあり（ランク D）",
    "rank_note_en": "ランクのメモ（英語）",
    "grading_company": "鑑定会社",
    "grade": "グレード",
    "grade_label": "グレード表記",
    "cert_number": "鑑定番号",
    "condition_note_en": "状態のメモ（英語）",
    "sealed_subtype": "未開封商品の種類",
    "seo_title": "検索エンジン用タイトル",
    "seo_description": "検索エンジン用説明",
    "media_urls": "画像のリンク",
    "game": "ゲーム",
    "set": "セット",
    "number": "カード番号",
    "language": "カードの言語",
    "kind": "種類（未鑑定・鑑定済み・未開封）",
    "rank": "ランク（A〜D）",
    "grader": "鑑定会社",
    "cert": "鑑定番号",
    "note": "メモ",
    "ref": "自分の管理番号",
    "name": "カード名"
  }
}
